/* import __COLOCATED_TEMPLATE__ from './fin-loading-icon.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-experience */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Element: HTMLDivElement;
}

const FinLoadingIcon = templateOnlyComponent<Signature>();
export default FinLoadingIcon;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Common::FinLoadingIcon': typeof FinLoadingIcon;
  }
}
